import { css } from '@emotion/core';
import { tokens, variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
var colors = tokens.colors;
export var emptyState = {
  name: "5o418b",
  styles: "position:relative;margin:auto;"
};
export var text = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.baseFontSize, ";color:", colour.primaryDark, ";margin:19px 0 11px;");
export var linkText = /*#__PURE__*/css("display:inline-block;vertical-align:top;color:", colors.neutral.heavy.default, ";font-weight:", font.headingFontWeight, ";");
export var linkIcon = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";");